/**
 *  auth.js (v1)
 *  @description: sesión del portal contra api-go. Convierte las respuestas
 *  a la forma que ya usan el contexto y el Sidebar.
 */
import api, { saveSession, clearSession, getSession } from '../../core/apiV1';

// login regresa { ok, message } o, si la cuenta tiene la contraseña de alta,
// { ok: false, activationToken } para pedir una nueva.
export async function login(email, password) {
   const res = await api.post('auth/web/login', { email: email.trim(), password });
   if (!res.ok) {
      const message =
         res.status === 401
            ? 'Usuario o contraseña incorrecta'
            : res.status === 403
            ? 'Tu usuario no tiene acceso al portal'
            : res.status === 429
            ? 'Demasiados intentos. Espera unos minutos.'
            : res.message;
      return { ok: false, message };
   }
   if (res.data.mustChangePassword) {
      return { ok: false, activationToken: res.data.activationToken };
   }
   saveSession(res.data);
   return { ok: true };
}

// activate fija la contraseña de una cuenta con la contraseña de alta y abre
// la sesión.
export async function activate(activationToken, password) {
   const res = await api.post('auth/activate', { password }, { bearer: activationToken });
   if (!res.ok) return { ok: false, message: res.message };
   saveSession(res.data);
   return { ok: true };
}

export function logout() {
   clearSession();
}

// currentUser regresa el usuario en la forma que usa el contexto
// (Nombre, NombrePerfil, IdPersona, Permisos). Confirma el token con /auth/me.
export async function currentUser() {
   const session = getSession();
   if (!session.auth || !session.token) return { error: true };
   const res = await api.get('auth/me');
   if (!res.ok) return { error: true };
   const u = res.data;
   const read = (u.permissions && u.permissions.lectura) || [];
   return {
      IdPersona: u.id,
      Nombre: u.name,
      Email: u.email,
      NombrePerfil: u.profileName,
      IdPerfil: u.profileId,
      Permisos: read,
      token: session.token,
   };
}

// menu regresa el árbol del Sidebar: [{IdMenu, Menu, Ruta, Icono, Parent, Submenu}]
export async function menu() {
   const res = await api.get('auth/me/menu');
   if (!res.ok) return [];
   const toLegacy = (m, parent) => ({
      IdMenu: m.id,
      Menu: m.name,
      Ruta: m.path,
      Icono: m.icon,
      Parent: parent,
      Submenu: (m.children || []).map((c) => toLegacy(c, m.id)),
   });
   return (res.data || []).map((m) => toLegacy(m, 0));
}

export async function changePassword(currentPassword, newPassword) {
   const res = await api.put('auth/password', { currentPassword, newPassword });
   return {
      ok: res.ok,
      message: res.ok ? 'Contraseña actualizada' : res.status === 400 || res.status === 401 ? 'La contraseña actual no coincide o la nueva no es válida (mínimo 8 caracteres).' : res.message,
   };
}

// --- recuperación con código de 6 dígitos por correo ---

export async function requestRecovery(email) {
   // La respuesta es la misma exista o no el correo.
   const res = await api.post('auth/password-recovery', { email: email.trim() });
   return { ok: res.ok, message: res.status === 429 ? 'Demasiadas solicitudes. Espera unos minutos.' : res.message };
}

export async function resetPassword(email, code, newPassword) {
   const verify = await api.post('auth/password-recovery/verify', { email: email.trim(), code });
   if (!verify.ok) {
      return { ok: false, message: verify.status === 429 ? 'Demasiados intentos. Solicita un código nuevo más tarde.' : 'El código no es válido o ya expiró.' };
   }
   const res = await api.post('auth/password-recovery/reset', { email: email.trim(), code, newPassword });
   return { ok: res.ok, message: res.ok ? 'Contraseña actualizada con éxito.' : res.message };
}
